import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
// components
import Background from '../components/Background/Background';
import MainHeader from '../components/MainHeader/MainHeader';
import Sidebar from '../components/Sidebar/Sidebar';
import ModulesPanel from '../components/ModulesPanel/ModulesPanel';
import VideoPlayer from '../components/VideoPlayer/VideoPlayer';
import ModalContainer from '../containers/ModalContainer/ModalContainer';
// utils
import get from 'lodash.get';
// shapes
import userShape from '../shapes/user';
// styles
import styles from './MainLayout.mod.css';
import classnames from 'classnames/bind';
import SubscriptionNotice from '../components/SubscriptionNotice/SubscriptionNotice';

const cx = classnames.bind(styles);

const disabledForUnsubscribedUrls = ['dashboard', 'recovery-plan', 'resources'];

class MainLayout extends Component {
  state = {
    isSidebarOpen: false,
  };

  toggleSidebar = () => {
    this.setState(prevState => ({
      isSidebarOpen: !prevState.isSidebarOpen,
    }));
  };

  render() {
    const {
      match,
      children,
      background,
      blobs,
      dashboardMenu,
      backLink,
      isLogged,
      user,
    } = this.props;

    const { isSidebarOpen } = this.state;
    const userColor = get(user, 'profile_color') || '#33C370';
    const hasSubscription = user.progress.subscription;

    /**
     * Disable all content if user has no subscription for some pages
     */
    const disabled =
      !hasSubscription &&
      disabledForUnsubscribedUrls.some(url =>
        Boolean(match.url.match(`/${url}`))
      ) &&
      user.progress.module > 0;

    return (
      <Background type={background} blobs={blobs} userColor={userColor}>
        <MainHeader toggleSidebar={this.toggleSidebar} backLink={backLink} />
        {isLogged && hasSubscription && (
          <Sidebar
            isOpen={isSidebarOpen}
            toggleSidebar={this.toggleSidebar}
            user={user}
          />
        )}
        {disabled && <SubscriptionNotice />}
        <div className={cx('container', { disabled })}>
          <div className={cx('content-wrapper')}>{children}</div>
          {isLogged && <ModulesPanel hidden={!dashboardMenu} />}
        </div>
        <VideoPlayer />
        <ModalContainer />
      </Background>
    );
  }
}

MainLayout.defaultProps = {
  blobs: true,
  background: 'primary',
  dashboardMenu: true,
};

MainLayout.propTypes = {
  blobs: T.bool,
  background: T.oneOf([
    'primary',
    'secondary',
    'grey',
    'congrats',
    'none',
    'profile',
  ]),
  user: userShape,
};

const enhance = compose(
  withRouter,
  connect(state => ({
    isLogged: state.auth.authenticated,
    user: state.auth.user,
  }))
);

export default enhance(MainLayout);



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.jsx